module.exports = __webpack_public_path__ + "img/rail-signals.9004d01c.png";